import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const features = [{
  bold: '6 Tomos técnicos',
  text: '— Herrero, Módena, A30, Cortes, Precios e Instalación'
}, {
  bold: '6 Bonos exclusivos',
  text: '— Scripts, Checklists, Croquis y Tracker de Ganancia'
}, {
  bold: '480 páginas',
  text: 'de contenido técnico listo para aplicar'
}, {
  bold: 'Lenguaje argentino',
  text: '— Líneas Módena, Herrero y A30 del mercado local'
}, {
  bold: 'Sin máquinas caras',
  text: '— Arrancás con herramientas básicas'
}];
export function SolutionSection() {
  return <section className="py-10 bg-matte text-white" data-id="element-292">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-293">
        <div className="text-center mb-8" data-id="element-294">
          <p className="text-base text-silver font-medium mb-1" data-id="element-295">
            Presentamos el
          </p>
          <h2 className="text-3xl md:text-5xl font-black text-white mb-2" data-id="element-296">
            SUPER COMBO
            <br data-id="element-297" />
            <span className="text-gold" data-id="element-298">CARPINTERÍA EN ALUMINIO</span>
          </h2>
          <p className="text-base text-silver font-medium" data-id="element-299">
            El único sistema que cubre fabricación, cálculo, precios e
            instalación para el mercado argentino
          </p>
          <div className="w-20 h-1 bg-gold mx-auto mt-4" data-id="element-300"></div>
        </div>

        <div className="flex justify-center mb-8" data-id="element-301">
          <img src="https://cdn.magicpatterns.com/uploads/geeQnDy3wQMCydhKCmLHyU/private_openrouter-generated-image-1776135192283.png" alt="Super Combo Carpintería en Aluminio" className="w-full max-w-xs h-auto" data-id="element-302" />
        </div>

        <div className="max-w-2xl mx-auto space-y-3" data-id="element-303">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="flex items-start bg-white/5 border border-silver/10 px-5 py-3" data-id="element-304">
              <Check className="w-5 h-5 text-gold mr-3 flex-shrink-0 mt-0.5" data-id="element-305" />
              <p className="text-base text-gray-300" data-id="element-306">
                <span className="font-bold text-white" data-id="element-307">{feature.bold}</span>{' '}
                {feature.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}